import { Component, ChangeDetectorRef, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import { Location } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith} from 'rxjs/operators';


import { ActivatedRoute } from '@angular/router';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { User, UserModel } from '../../../shared/models/user.model';
import { PlayerListService } from '../../../shared/services/player-list.service';
import { UserService } from '../../../shared/services/user.service';
import { PlayerListSecurity } from '../../../shared/models/PlayerListModels';
import { TranslatePipe } from '@ngx-translate/core';
import { MaterialModule } from "../../../material/material.module";
import { MatToolbarModule } from '@angular/material/toolbar';



@Component({
    selector: 'app-ranking-list-edit',
  imports: [CommonModule, ReactiveFormsModule, MatAutocompleteModule,
    MatButtonModule, MatInputModule, MatFormFieldModule, MatCheckboxModule,
    MatListModule, MatSelectModule, TranslatePipe, MaterialModule, MatToolbarModule],
  standalone: true,
    templateUrl: './ranking-list-edit.component.html',
    styleUrl: './ranking-list-edit.component.css'
})
export class RankingListEditComponent implements OnInit {
  
  
  _form: UntypedFormGroup;
  filteredCategories: Observable<string[]>;
  categories: string[] = [];
  users: UserModel[];
  selected: string[];
  loadedCats: boolean = false;
  loadedUsers: boolean = false;
  loadedList: boolean = false;  
  readyLoading: boolean = false;
  isLoading: boolean = false;
  theListId: string;
  
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);


  constructor( 
    private route: ActivatedRoute, 
    public formBuilder: UntypedFormBuilder,
    private listService: PlayerListService,
    private userService: UserService,
    private readonly location: Location
   ) {}
  
  ngOnInit(){
    this.theListId = this.route.snapshot.paramMap.get('ListId') ?? "";
    if (!this.theListId) {
      this.isLoading = false;
      this.loadedList = false;
      this.loadedCats = false;
      this.loadedUsers = false;
      this.cdr.detectChanges();
      return;
    }

    this.isLoading = true;
    this.loadedList = false;
    this.loadedCats = false;
    this.loadedUsers = false;

    this.listService.getListDetails(this.theListId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (list) => {
          this._form = this.formBuilder.group({
            Description: [list.Description, [Validators.required]],
            Category: list.Category,
            PlayerListSecurity: this.formBuilder.array([])
          });
          this.loadedList = true;

          this.filteredCategories = this._form.controls['Category'].valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value)),
          );

          this.listService.getCategories()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: (data) => {
                this.categories = data as string[];
                this.loadedCats = true;
                this.getUsers(list.PlayerListSecurity);
                this.cdr.detectChanges();
              },
              error: (err) => {
                // console.error('Error loading categories:', err);
                this.isLoading = false;
                this.cdr.detectChanges();
              }
            });
        },
        error: (err) => {
          // console.error('Error loading list details:', err);
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  submit(){
    // console.log('Ranking list edit - submitting form');
    //console.log(this._form.value);
    var security: PlayerListSecurity[] = [];
    this._form.controls['PlayerListSecurity'].value.forEach((sec: PlayerListSecurity) => { 
      //console.log(sec);
      if(sec.value===true || sec.CanEdit==true){
        var data: PlayerListSecurity = new PlayerListSecurity();
        data.UserId = sec.UserId;     
        data.CanEdit = sec.CanEdit;   
        security.push(data);
      }
      
    });
    
      //console.log("Update");
      this.listService.updateList(this.theListId, this._form.controls['Description'].value, this._form.controls['Category'].value, false, security)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (result) => {
            // console.log('Ranking list edit - update successful');
            //this.dialogRef.close(result);
            this.goback();
          },
          error: (err) => {
            // console.error('Error updating list:', err);
          }
        });

 
   
  }

  
  getUsers(security: PlayerListSecurity[]){
    this.userService.getAllScoutsActive()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.users = data as UserModel[];
          //console.log('users');
          var accessrights = this._form.get('PlayerListSecurity') as UntypedFormArray;
          this.users.forEach((e) => {
            const SecurityUser =  security.find(user => user.UserId== e.UserId );
            var CanEdit=false;
            if(SecurityUser!=undefined)
              CanEdit = SecurityUser.CanEdit;
            accessrights.push(
              this.formBuilder.group({
                UserId: e.UserId,
                FullName: e.LastName + ', ' + e.FirstName,
                UserName: e.Email,
                value: security.some(user => user.UserId === e.UserId),
                CanEdit: CanEdit
              }) 
            );  
          });
          //console.log("loaded Users");
          this.loadedUsers = true;
          this.isLoading = false;
          // console.log(this._form.value);
          this.cdr.detectChanges();
        },
        error: (err) => {
          // console.error('Error loading users:', err);
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });

      //console.log(this._form.value);
  }

  get PlayerListSecurity(): UntypedFormArray{
    return this._form.get('PlayerListSecurity') as UntypedFormArray;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    // console.log("_filter");
    return this.categories.filter(option => option?.toLowerCase().includes(filterValue));
    
  }

  goback(){
    this.location.back();
  }
}
